export default function(ac, app) {
    var grupaRada = app.getEntity('GrupaRada');

    grupaRada.listView()
        .title('Grupa rada')
        .icon('<i class="fa fa-archive fa-3x"></i>')
        .fields([
            ac.field('naziv')
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    grupaRada.editionView()
        .title('Grupa rada')
        .fields([
            {
                key:'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv',
                    required: true,
                    focus: true
                }
            },
        ]);

    return grupaRada;
}



// WEBPACK FOOTER //
// ./app/components/grupaRada/config.js